export const MAP_STYLE = "mapStyle";
